<clr-vertical-nav [clrVerticalNavCollapsible]="true" [(clrVerticalNavCollapsed)]="collapsed" class="nav-trigger&#45;&#45;bottom" *transloco="let t; prefix: 'sidenav'">
  <a clrVerticalNavLink routerLink="/dashboard/pps" routerLinkActive="active">
    <cds-icon shape="home"></cds-icon>
    <b> {{ t('dashboard') }}</b>
  </a>
  <div class="nav-divider"></div>
  <clr-vertical-nav-group
    routerLinkActive="active" [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="tasks" clrVerticalNavIcon></cds-icon>
    {{ t('projects') }}
    <clr-vertical-nav-group-children>
      <a clrVerticalNavLink routerLink="/projects/overview" routerLinkActive="active"> {{ t('overview') }}</a>
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>
  <div class="nav-divider"></div>
  <clr-vertical-nav-group
    routerLinkActive="active" [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="contract" clrVerticalNavIcon></cds-icon>
    {{ t('jobs') }}
    <clr-vertical-nav-group-children>
      <a clrVerticalNavLink routerLink="/jobs/overview" routerLinkActive="active"> {{ t('overview') }}</a>
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>
  <div class="nav-divider"></div>
  <clr-vertical-nav-group
    routerLinkActive="active" [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="employee-group" clrVerticalNavIcon></cds-icon>
    {{ t('contacts') }}
    <clr-vertical-nav-group-children>
      <a clrVerticalNavLink routerLink="/contacts" routerLinkActive="active"> {{ t('companies') }}</a>
      <a clrVerticalNavLink routerLink="/persons" routerLinkActive="active"> {{ t('people') }}</a>
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>
  <div class="nav-divider"></div>
  <clr-vertical-nav-group
    routerLinkActive="active" [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="wrench" clrVerticalNavIcon></cds-icon>
    {{ t('components') }}
    <clr-vertical-nav-group-children>
      <a clrVerticalNavLink [routerLink]="['/component/overview', true]" routerLinkActive="active"> {{ t('overview') }}</a>
      <a clrVerticalNavLink routerLink="/component/assembly" routerLinkActive="active"> {{ t('assemblies') }}</a>
      <a clrVerticalNavLink routerLink="/component/standard" routerLinkActive="active"> {{ t('standardParts') }}</a>
      <a clrVerticalNavLink routerLink="/component/technology" routerLinkActive="active"> {{ t('process') }}</a>
      <a clrVerticalNavLink [routerLink]="['/component/passive', false]" routerLinkActive="active"> {{ t('passiveParts') }}</a>
      <a clrVerticalNavLink routerLink="/component/add" routerLinkActive="active"> {{ t('addComponent') }}</a>
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>
  <div class="nav-divider"></div>
  <clr-vertical-nav-group
    routerLinkActive="active" [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="calculator" clrVerticalNavIcon></cds-icon>
    {{ t('requests') }}
    <clr-vertical-nav-group-children>
      <a clrVerticalNavLink routerLink="/requests/overview" routerLinkActive="active"> {{ t('overview') }}</a>
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>
  <div class="nav-divider"></div>
  <clr-vertical-nav-group
    routerLinkActive="active" [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="contract" clrVerticalNavIcon></cds-icon>
    {{ t('orders') }}
    <clr-vertical-nav-group-children>
      <a clrVerticalNavLink routerLink="orders" routerLinkActive="active">{{ t('overview') }}</a>
      <a clrVerticalNavLink routerLink="/orders/idea" routerLinkActive="active"> Idee für später</a>
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>
  <div class="nav-divider"></div>
  <clr-vertical-nav-group
    routerLinkActive="active" [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="calculator" clrVerticalNavIcon></cds-icon>
    {{ t('offers') }}
    <clr-vertical-nav-group-children>
      <a clrVerticalNavLink routerLink="/offers/overview" routerLinkActive="active">{{ t('overview') }}</a>
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>
  <div class="nav-divider"></div>
  <clr-vertical-nav-group
    routerLinkActive="active" [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="wallet" clrVerticalNavIcon></cds-icon>
    {{ t('invoices') }}
    <clr-vertical-nav-group-children>
      <a clrVerticalNavLink routerLink="/invoices/overview" routerLinkActive="active"> {{ t('overview') }}</a>
      <a clrVerticalNavLink routerLink="/delivery/overview/open" routerLinkActive="active"> {{ t('deliveries') }}</a>
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>
  <div class="nav-divider"></div>
  <clr-vertical-nav-group
    routerLinkActive="active" [clrVerticalNavGroupExpanded]="true">
    <cds-icon shape="filter-grid-circle" clrVerticalNavIcon></cds-icon>
    Lager
    <clr-vertical-nav-group-children>
      <a clrVerticalNavLink routerLink="/warehouse/overview" routerLinkActive="active">Übersicht</a>
    </clr-vertical-nav-group-children>
  </clr-vertical-nav-group>
  <div class="nav-divider"></div>
  <a clrVerticalNavLink routerLink="/dashboard/pps" routerLinkActive="active">
    <cds-icon shape="certificate" clrVerticalNavIcon></cds-icon>
    <b>{{ t('qm') }}</b>
  </a>
  <div class="nav-divider"></div>
  <a clrVerticalNavLink routerLink="/dashboard/pps" routerLinkActive="active">
    <cds-icon clrVerticalNavIcon shape="piggy-bank"></cds-icon>
    <b>{{ t('balance') }}</b>
  </a>

</clr-vertical-nav>
